import React, { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next';
import "../Styles/ShareStudyLinkCss.css";
import { CopyIcon } from '@fluentui/react-icons-mdl2';
import { Checkbox, Icon, TextField } from '@fluentui/react';
import themeContext from '../../../../context/theme/ThemeContext';

const ShareStudyLinkBody = (props) => {
    const [t] = useTranslation();
    const { getThemeColor,getAlterColor ,themeName} = useContext(themeContext);
    const handleCopyUrl = () =>{
        let hiddenMessage =document.getElementById('copied-msg');
        let copyText = document.getElementById('url');
        copyText.select();
        copyText.setSelectionRange(0, 99999);

        navigator.clipboard.writeText(copyText.value);
        hiddenMessage.style.visibility = "visible";
    }

    const textFieldStyle = {
      fieldGroup: {
        '&.is-disabled': {
          background: 'transparent !important',
          border:'1px solid rgba(200, 198, 196, 0.3) !important',
          cursor:'not-allowed',
        },
      },
      root:{
        width:'100%',
        borderRadius: '7px',
        '&.is-disabled': {
          backgroundColor: 'transparent !important',
          cursor:'not-allowed',
          border:'none !important'
        },
      },
      field: {
            backgroundColor: 'transparent !important',
            border:'1px solid rgba(200, 198, 196, 0.3) !important'
      },
    }

    const checkBoxStyle = {
        root: {
          paddingLeft: "5px"
        },
        checkbox: {
          borderColor: "#8A8886",
          width: "16px",
          height: "16px"
        },
      };

      const textFieldStyles = {
        root: {
          userSelect: 'none', // Make the text unselectable
        },
      };


      const handleContextMenu = (e) => {
        e.preventDefault(); // Prevent right-click context menu
      };
    
      const handleCopy = (e) => {
        e.preventDefault(); // Prevent Ctrl+C
      };

  return (
    <div className="share-study-container">
                <div className='share-study-content'>
                    <div className='closeStudyContentContainer'>
                    <div className='content-2'>
                        <label style={{color: getThemeColor('primary-color')}} className='label'>{t("share-study.url")}</label>
                        <div className='url-copy-container'>
                        <div className='url-fields'>
                            <TextField
                                className="url-textArea1" 
                                id="url"
                                name="other"
                                value={props.values.studyShareUrl}
                                styles={textFieldStyles}
                                onContextMenu={handleContextMenu}
                                onCopy={handleCopy}
                                // disabled={true}
                            />
                            <h3 className="copied-msg" id="copied-msg" 
                            style={{
                              color: themeName === "light" ? "#0078D4" : "",
                              }}
                            >{t("share-study.link-copied-successfully")}</h3>
                        </div>
                        {/* <PrimaryButton
                            text={t("button.copy")}
                            onClick={handleCopyUrl}
                        /> */}
                        <div style={{display:'flex',alignItems:'start',marginTop:'5px',marginRight:'5px'}}>
                        <Icon iconName="copy" style={{fontSize:'20px',color:getAlterColor("#ffffffad",""),cursor:'pointer'}} onClick={handleCopyUrl}></Icon>
                        </div>
                        
                        </div>
                    </div>
                    {(process.env.REACT_APP_ENABLE_EMAIL_ON_SHARE_STUDY == "true" || process.env.REACT_APP_ENABLE_EMAIL_ON_SHARE_STUDY == true) && <div className='content-2' style={{display:'flex'}}>
                        <div className='shareStudy-email-label' style={{marginRight:'10px'}}>
                            <Checkbox styles={checkBoxStyle} checked={props.isEmailChecked} defaultChecked={true} id="email-checkbox" onChange={props.handleEmailcheck}/>
                            <label style={{color: getThemeColor('primary-color')}} className='shareStudy-emailLabel'>{t("share-study.email")}</label>
                        </div>
                        <TextField
                        className="textArea" 
                        name="email"
                        styles={textFieldStyle}
                        placeholder={t("share-study.placeholder.email")}
                        onChange={props.isEmailChecked?props.handleChange:()=>{}}
                        disabled={!props.isEmailChecked}
                        value={props.values.email}
                        errorMessage={props.errors.email}
                        />
                    </div>}
                    </div>
                </div>
            </div>
  )
}

export default ShareStudyLinkBody